

































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockTakingView extends Vue {
  public items: Common.StockTaking[] = new Array(0);
  public params: Common.StockTakingQuery = new Common.StockTakingQuery();
  public importQuery = new Common.ImportQuery('棚卸処理','StockTaking');
  public exportQuery = new Common.ExportQuery('棚卸処理',this.params);
  public sortOptions: any = [
    { value: 'State', text:'状態' },    
    { value: 'stockTakingNo', text: '棚卸処理番号' },
    { value: 'bookDate', text: '発生日' },    
    { value: 'warehouse', text: '倉庫' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },        
  ];
  public savingFlag: Common.StockTakingStatus = Common.StockTakingStatus.PostWaiting;
  public voucherTypes = Common.voucherTypes;  
  @Prop() public stockTakingNo:string;


  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.stock) > 0 ;
  }

  public created() {
    // 検索条件を設定する
    if(this.stockTakingNo) {
      this.params.stockTakingNo = this.stockTakingNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.SalesCharge) {
    const workflows = this.$api.formatter.getOptions('workflow_stockTaking');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //棚卸処理明細タブのリロード
    (this.$refs.stockTakingItems as Components.GrdVoucherItem).onVoucherNoChanged();           
  }

  // 一覧選択時に明細表示ボタンを非活化状態を更新
  public onSelected(index: number, selected: Common.StockTaking) {
    // 明細表示ボタンの非活化状態を更新
    this.updateDisabledShowItemButton(selected);
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  updateDisabledShowItemButton(stockRelocation:Common.StockTaking){
    this.disabledShowItemButton = true;
    
    var query = new Common.GetStockTakingItemQuery();
    query.stockTakingNo = stockRelocation.stockTakingNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = res.length == 0;
    });
  }

  // 棚卸処理明細一覧を表示
  public showStockTakingItems() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.StockTaking;
    let routeData = this.$router.resolve(String.format('/journal/StockTakingItem?stockTakingNo={0}',obj.stockTakingNo));
    window.open(routeData.href, '_blank');
  }

  //在庫選択画面を表示して在庫移動を実行する(追加モード)
  public showStockBalance:boolean = false;
  public onAddItems(item : Common.StockTaking){
    //在庫移動メニューを起動する
    var stockBalance = this.$refs.stockBalance as Components.StockBalance;
    stockBalance.astkBookDate = item.bookDate;
    stockBalance.astkWarehouse = item.warehouseOut;
    stockBalance.astkPic =item.pic;
    stockBalance.astkWorkflowId = item.workflowId;
    stockBalance.astkClosingDate = item.bookDate;
    stockBalance.astkSegment = item.segment;
    stockBalance.astkRefNo = item.refNo;
    stockBalance.astkBarcodeInspection = item.barcodeInspection;
    stockBalance.astkStockTaking = item;
    stockBalance.astkUpdatedHandler= this.onComplete;
    stockBalance.showStockTakingDialog();
  }
  public onComplete() {
    // 在庫移動子画面で保存が成功した場合の後続処理
    // ①在庫選択画面を非表示にする
    // ②明細タブをリロードする        
    this.showStockBalance = false;
    (this.$refs.stockTakingItems as Components.GrdVoucherItem).onVoucherNoChanged();
  }  
}
